import { OwaConnectedAccountInitSource } from '../schema/OwaConnectedAccountInitSource';
import { getApolloClient } from 'owa-apollo';
import { AccountSourceListDocument } from 'owa-mail-account-store';
import { trace } from 'owa-trace';
import { initializeOwaConnectedAccountV2 } from '../utils/initializeOwaConnectedAccountV2';

export async function initializeOwaAccountsStoreFromAccountSourceList() {
    trace.info(
        '[owa-accounts-store-init] initializing OWA Connected accounts store from GQL Account Source List'
    );
    const apolloClient = getApolloClient();
    const results = await apolloClient.query({ query: AccountSourceListDocument });
    results.data.accountSourceList.map(account =>
        initializeOwaConnectedAccountV2(account, OwaConnectedAccountInitSource.Init)
    );
    return true;
}
